import type { Action } from 'state/actions';
import { addOrPatchKey } from 'state/utils/collection';

import type { PriceImprovementResponsesMap } from './priceImprovementResponse.model';

export function priceImprovementResponsesReducer(
  state: PriceImprovementResponsesMap = {},
  action: Action,
): PriceImprovementResponsesMap {
  switch (action.type) {
    case 'PRICE_IMPROVEMENT_RESPONSE_COMMENT_CHANGED':
      return addOrPatchKey(state, action.requestForPriceImprovementId, _ => ({
        comment: action.comment,
      }));
    case 'PRICE_IMPROVEMENT_RESPONSE_ACCEPTABLE_PRICE_ADJUSTMENT_CHANGED':
      return addOrPatchKey(state, action.requestForPriceImprovementId, _ => ({
        acceptablePriceAdjustment: action.acceptablePriceAdjustment,
      }));
    case 'PRICE_IMPROVEMENT_RESPONSE_ERROR_DISMISSED':
    case 'PRICE_IMPROVEMENT_VALIDATED':
    case 'PRICE_IMPROVEMENT_REJECTED':
      return addOrPatchKey(state, action.requestForPriceImprovementId, _ => ({
        validationError: undefined,
        rejectionError: undefined,
      }));
    case 'PRICE_IMPROVEMENT_VALIDATE_FAILED':
      return addOrPatchKey(state, action.requestForPriceImprovementId, _ => ({
        validationError: action.error,
      }));
    case 'PRICE_IMPROVEMENT_REJECT_FAILED':
      return addOrPatchKey(state, action.requestForPriceImprovementId, _ => ({
        rejectionError: action.error,
      }));
    default:
      return state;
  }
}
